export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_12.d29c7d3b.jpg";